export function removeIndex<T>(arr: readonly T[], index: number): T[] {
  return arr.slice(0, index).concat(arr.slice(index + 1));
}

export function paginate<T>(items: T[], page: number, pageSize: number): T[] {
  return items.slice(page * pageSize, pageSize);
}
